<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.surveys', 2),
                        href: meta.links.survey_index,
                    },
                    {
                        name: survey.title,
                        href: meta.links.survey_show,
                    },
                    {
                        name: record.date_display,
                        href: null,
                    },
                    {
                        name: record.user_name,
                        href: null,
                    },
                ]"
            >
                <template v-slot:corner>
                    <div>
                        <ActivityMenuOptions>
                            <InertiaLink
                                v-for="otherStudent in meta.links.otherStudents"
                                :href="otherStudent.url"
                                :key="otherStudent.url"
                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                                role="menuitem"
                            >
                                {{ otherStudent.text }}
                            </InertiaLink>
                        </ActivityMenuOptions>
                    </div>
                </template>
            </SmartBreadcrumbs>
        </template>
        <div>
            <SurveyRecordDisplay :survey="survey" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SurveyRecordDisplay from './partials/SurveyRecordDisplay.vue';
import ActivityMenuOptions from '@/components/pageSpecific/ActivityMenuOptions.vue';

export default {
    components: {
        ActivityMenuOptions,
        SurveyRecordDisplay,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'survey', 'record'],
};
</script>
